export const SET_USER = 'user';
export const SET_PASSWORD = 'password';
export const CLEAR_DATA = 'clearData';
export const LOADING = 'loading';
export const SET_ERROR = 'error';
